/** Inline workday-duration editor: reads as "5d", click to type a number. */
import React from "react";
import CommitInput from "../CommitInput/CommitInput";

const DurationCell: React.FC<{
  days: number;
  onCommit: (days: number) => void;
}> = ({ days, onCommit }) => {
  const [editing, setEditing] = React.useState(false);
  if (!editing) {
    return (
      <button
        type="button"
        className="dep-table-dur-btn"
        title="Change duration (workdays)"
        onClick={() => setEditing(true)}
      >
        {days}d
      </button>
    );
  }
  return (
    <CommitInput
      className="dep-table-dur-input"
      initial={String(days)}
      onCommit={(v) => {
        setEditing(false);
        const n = Math.round(Number(v));
        if (Number.isFinite(n) && n >= 1 && n !== days) onCommit(n);
      }}
      onCancel={() => setEditing(false)}
    />
  );
};

export default DurationCell;
